module.exports = __webpack_public_path__ + "img/ico_btn_notice.041ec49.svg";